<template>
<div>
    <!-- <el-form :model="basicFormData" :rules="dataRule" ref="basicFormData" @keyup.enter.native="dataFormSubmit()" label-width="150px"> -->
    <!-- TODO: 类型 招标 议标 招标：几个供应商 第一轮报价截止之前，看不到报价 除非所有供应商提前报价完毕了， 第二轮规则一样，可以看前几轮历史 -->
    <!-- TODO: 类型 招标 议标 议标：第一轮报价截止之前，看不到报价 除非所有供应商提前报价完毕了 -->
    <!-- TODO: 量产按照议标做 -->
    <!-- 价格TAB页 基本信息 -->
    <!-- 修改成供应商列表 -->
    <el-button v-if="!viewFlag && addVisible" type="primary" plain size="small" @click="selectSupplier()" style="float: right; margin-bottom: 15px;" icon="el-icon-plus">选择供应商</el-button>
    <!-- <el-button v-if="basicFormData.rfqStatus === RFQ_STATUS.RFQSTART && userInfo.typeId !== USER_TYPE.SUPPLIER" style="float:right" size=mini @click="addOrUpdateSupplierHandle()">添加供应商</el-button> -->
    <!-- <el-button v-if="addVisible" style="float:right" size=mini @click="addOrUpdateSupplierHandle()">添加供应商</el-button> -->
    <!-- <el-form-item label="推荐供应商(采购员可见)" prop="orderRequirement"> -->
    <el-table ref="supplierTable" :data="supplierList" row-key="rfqVenderId" :header-cell-style="{background:'#f5f5f5'}" size="mini" border style="width: 100%; margin: 10px 10px 0 0 ;" :default-expand-all="false" @selection-change="handlerSelectionChange">
        <el-table-column v-if="basicFormData.times >= 0 && !viewFlag && addVisible" type="selection" width="55">
        </el-table-column>
        <el-table-column type="index" width="50" label="序号">
        </el-table-column>
        <el-table-column prop="rfqSupplierName" header-align="center" align="left" label="推荐供应商名称">
        </el-table-column>
        <el-table-column prop="rfqSupplierCode" header-align="center" align="left" label="供应商编码" width="100">
        </el-table-column>
        <el-table-column prop="rfqVenderLoginName" header-align="center" align="left" width="150" label="供应商用户名">
        </el-table-column>
        <el-table-column prop="rfqSupplierType" header-align="center" align="center" label="类型" width="50">
            <template slot-scope="scope">
                {{SUPPLY_TYPE_VALUE(scope.row.rfqSupplierType)}}
            </template>
        </el-table-column>
        <el-table-column prop="rfqSupplierReplyStatus" header-align="center" align="center" label="回复状态" width="100">
            <template slot-scope="scope">
                {{QUOTATION_STATUS_VALUE(scope.row.rfqSupplierReplyStatus)}}
            </template>
        </el-table-column>
        <el-table-column prop="rfqSupplierReplyStatus" header-align="center" align="center" label="是否最终报价" width="100">
            <template slot-scope="scope">
                {{scope.row.lastFlag === 1 ? '是' : '否'}}
            </template>
        </el-table-column>
        <el-table-column prop="rfqSupplierExpierence" header-align="center" align="left" label="项目经验">
        </el-table-column>
        <el-table-column v-if="!viewFlag" header-align="center" align="left" width="210" label="操作">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="addOrUpdateSupplierHandle(scope.row.id)" icon="el-icon-edit">
                    修改
                </el-button>
                <el-button type="text" size="small" @click="deleteSupplierHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                    删除
                </el-button>
                <el-popover placement="bottom" width="400" trigger="click">
                    <el-table :data="fileList" :header-cell-style="{background:'#f5f5f5'}" border style="width: 100%; margin-bottom:15px" size="mini">
                        <el-table-column prop="originalName" header-align="center" align="left" label="文件名称">
                        </el-table-column>
                        <el-table-column prop="fileSize" header-align="center" align="right" label="文件大小">
                            <template slot-scope="scope">
                                {{toSize(scope.row.fileSize,null)}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="fileDir" header-align="center" align="center" width="120" label="查看附件">
                            <template slot-scope="scope">
                                <el-button icon="el-icon-view" type="text" @click="viewHandle(scope.row)">下载</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-button type="text" slot="reference" size="small" @click="getAttachment(scope.row.id)" icon="el-icon-link">
                        查看附件
                    </el-button>
                </el-popover>
            </template>
        </el-table-column>
    </el-table>
    <!-- </el-form> -->
    <supplier-select-dialog v-if="supplierSelectDialogVisible" :basicFormData="basicFormData" ref="supplierSelectDialog"></supplier-select-dialog>
    <supplier-add-or-update v-if="addOrUpdateVisible" ref="supplierAddOrUpdate"></supplier-add-or-update>
</div>
</template>

<script>
// import {
//     getQuotationDetail,
//     editQuotation,
//     createQuotation
// } from '@/controller/quotation'
import {
    deleteRfqSupplier
} from '@/controller/rfq'
import {
    DIALOG_CLOSED_TYPE,
    RFQ_STATUS,
    USER_TYPE,
    QUOTATION_STATUS,
    getQUOTATION_STATUS_VALUE,
    getSUPPLY_TYPE_VALUE,
    getSUPPLY_RFQ_STATUS_VALUE,
} from '@/utils/const';
import moment from 'moment';
import SupplierSelectDialog from "./supplier-select-dialog";
import SupplierAddOrUpdate from './supplier-add-or-update.vue'
import {
    getFileList,
    getUrl
} from '@/controller/sys'
import {
    toFileSize
} from '@/utils'
const allowAddSet = new Set([RFQ_STATUS.BEGIN, RFQ_STATUS.BEFORE_ASK, RFQ_STATUS.ASKING])
// require('@/mock/mockQuotation');
export default {
    props: {
        //供应商列表数据
        basicFormData: Object,
        supplierList: Array,
        viewFlag: Boolean

    },
    data() {
        return {
            DIALOG_CLOSED_TYPE: DIALOG_CLOSED_TYPE,
            RFQ_STATUS: RFQ_STATUS,
            QUOTATION_STATUS: QUOTATION_STATUS,
            QUOTATION_STATUS_VALUE: getQUOTATION_STATUS_VALUE,
            SUPPLY_TYPE_VALUE: getSUPPLY_TYPE_VALUE,
            SUPPLY_RFQ_STATUS_VALUE: getSUPPLY_RFQ_STATUS_VALUE,
            flowableType: '', //TODO:
            userInfo: this.$store.state.user.userInfo,
            USER_TYPE: USER_TYPE,
            supplierSelectDialogVisible: false,
            addOrUpdateVisible: false,
            dataForm: {
                id: 0,
                venderName: '',
                email: '',
                email2: '',
                venderExpierence: '',
                supplierLevel: 0,
                rfqSupplierReplyStatus: 0,
                rfqId: '',
            },
            fileList: []
        }
    },
    computed: {
        addVisible() {
            if (this.basicFormData && this.basicFormData.rfqStatus) {
                const type = this.basicFormData.rfqStatus
                return allowAddSet.has(type)
            }
            return false
        }
    },
    mounted() {},
    components: {
        SupplierSelectDialog,
        SupplierAddOrUpdate,
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD前")
        },
        selectSupplier(id) {
            this.supplierSelectDialogVisible = true;
            this.$nextTick(() => {
                // const _this = this
                const ids = []
                this.supplierList.forEach(supplier => {
                    ids.push(supplier.rfqVenderId)
                });
                this.$refs.supplierSelectDialog.open(ids);
                this.$refs.supplierSelectDialog.onClosed = (payload) => {
                    if (payload.option === DIALOG_CLOSED_TYPE.CONFIRM) {
                        this.$emit('refreshSupplierList')
                    }
                };
            });
        },
        dateFormatValue: function (value) {
            if (!value) {
                return ''
            }
            return moment(value).format("YYYY-MM-DD")
        },
        addOrUpdateSupplierHandle(id) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.supplierAddOrUpdate.init(id);
            })
        },
        deleteSupplierHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteRfqSupplier({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.$emit('refreshSupplierList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        handlerSelectionChange(rows) {
            this.$emit('selectionChange', rows)
        },

        getAttachment(id) {

            this.getFileList(id)
        },
        async getFileList(bizId) {
            console.log(bizId, 'bizId ==========================')
            if (!bizId) return
            // alert(this.basicFormData.bizId)
            try {
                // this.loading = true

                const params = {
                    id: bizId,
                    bizType: 13,

                }
                const res = await getFileList(params)
                if (res && res.code === '00') {
                    this.fileList = Array.isArray(res.body) ? res.body : []
                } else {
                    this.fileList = []
                }

            } catch (e) {
                console.log(e)
            } finally {
                // this.loading = false
            }
        },
        viewHandle(row) {
            const params = {
                fileId: row.id
            }
            getUrl(params).then(data => {
                if (data && data.code === '00' && data.body) {
                    this.download(data.body, row.originalName)
                } else {
                    // this.fileList = []
                }
            })
        },
        download(url, filename) {
            const _this = this
            this.getBlob(url, function (blob) {
                _this.saveAs(blob, filename);
            });
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            } else {
                var link = document.createElement("a")
                var body = document.querySelector("body")

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                // fix Firefox
                link.style.display = "none"
                body.appendChild(link)

                link.click()
                body.removeChild(link)

                window.URL.revokeObjectURL(link.href)
            }
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open("GET", url, true)
            xhr.responseType = "blob"
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response);
                }
            }
            xhr.send()
        },
        toSize(byte, format) {
            return toFileSize(byte, format)
        },
    }
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}

.mt20 {
    margin-top: 20px;
}
</style>
